import React, { useState, useEffect } from "react";
import { Card, Button, Space } from "antd";
import {
	ArrowLeftOutlined,
	SettingOutlined,
	UserAddOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PageTitle from "../PageTitle";
import AdminCourses from "./AdminCourses";
import { isTokenValid } from "../../utilities/AuthService";
import PageHeader from "../common/PageHeader";

const AdminPage = () => {
	const navigate = useNavigate();
	const [isCmaStaff, setIsCmaStaff] = useState(false);

	useEffect(() => {
		// Check if user is in cma_staff group
		if (isTokenValid()) {
			const groupStr = localStorage.getItem("user_groups");
			if (groupStr) {
				try {
					const groups = JSON.parse(groupStr);
					setIsCmaStaff(
						groups.includes("cma_staff"),
					);
				} catch (error) {
					console.error(
						"Error parsing user groups:",
						error,
					);
				}
			}
		}
	}, []);

	const handleBackToCma = () => {
		navigate("/cma");
	};

	const handleAddBulkEnrollments = () => {
		navigate("/cma/admin/enrollments/bulk");
	};

	return (
		<div
			className="page"
			style={{
				padding: "24px",
				backgroundColor: "var(--c-bg)",
				minHeight: "100vh",
			}}>
			<PageTitle title="기독사관학교 - 관리자 페이지" />

			{/* Header */}
			<PageHeader
				title={
					<>
						<SettingOutlined style={{ marginRight: 8 }} />
						관리자 페이지
					</>
				}
				actions={
					<Button
						icon={<ArrowLeftOutlined />}
						onClick={handleBackToCma}>
						나의 강의실로 돌아가기
					</Button>
				}
			/>

			{/* Staff Actions */}
			{isCmaStaff && (
				<Card className="surface-card">
					<Space
						direction="vertical"
						style={{ width: "100%" }}>
						<Button
							type="primary"
							size="large"
							icon={
								<UserAddOutlined />
							}
							onClick={
								handleAddBulkEnrollments
							}
							block>
							다중 수강 신청 등록
						</Button>
					</Space>
				</Card>
			)}

			{/* Admin Content */}
			<AdminCourses />
		</div>
	);
};

export default AdminPage;
